import { supabase } from '../supabase/supabaseClient';

export const getSkills = async (search = '', limit = 10, offset = 0) => {
  let query = supabase
    .from('skills')
    .select('*', { count: 'exact' })
    .order('category, name', { ascending: true });

  if (search) {
    query = query.or(`name.ilike.%${search}%,description.ilike.%${search}%`);
  }

  if (limit !== "All") {
    query = query.range(offset, offset + limit - 1);
  }

  const { data, count, error } = await query;

  if (error) throw error;
  return { data, count };
};

export const addSkill = async (name, description) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));

    const { data, error } = await supabase
      .from('skills')
      .insert([{
        name,
        description,
        created_by: user.id,
        created_at: new Date().toISOString()
      }])
      .select();

    if (error) throw error;

    return { success: true, data: data[0] };
  } catch (error) {
    console.error('Error add skill:', error);
    return { success: false, message: error.message };
  }
};

export const updateSkill = async (id, name, description) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) throw new Error('User not found in localStorage');

    const { error: updateError } = await supabase
      .from('skills')
      .update({
        name: name,
        description: description,
        updated_at: new Date().toISOString(),
        updated_by: user.id
      })
      .eq('id', id);

    if (updateError) throw updateError;

    return { success: true };
  } catch (error) {
    console.error('Error update skill:', error);
    return { success: false, error };
  }
};

export const deleteSkill = async (id) => {
  try {
    // 1️⃣ delete relasi dulu
    const { error: relError } = await supabase
      .from('member_skills')
      .delete()
      .eq('skill_id', id);

    if (relError) {
      return { success: false, message: relError.message };
    }

    // 2️⃣ baru delete skill
    const { error: skillError } = await supabase
      .from('skills')
      .delete()
      .eq('id', id);

    if (skillError) {
      return { success: false, message: skillError.message };
    }

    return { success: true };
  } catch (error) {
    console.error('Error delete skill:', error);
    return { success: false, message: 'Unexpected error' };
  }
};



